var React = require('react');

function ConfettiImg7 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.38055 12.3126C6.35946 7.09398 -1.37141 6.42195 4.16756 1.77889","stroke":"#CCEDD6","strokeWidth":"2.43566","strokeLinecap":"round"}));
}

ConfettiImg7.defaultProps = {"width":"6","height":"14","viewBox":"0 0 6 14","fill":"none"};

module.exports = ConfettiImg7;

ConfettiImg7.default = ConfettiImg7;
